import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = "tagforce-access-token";
const NO_RETRY = ["/auth/login", "/auth/refresh", "/auth/logout", "/auth/forgot-password", "/auth/reset-password"];

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const accessToken = window.localStorage.getItem(TOKEN_KEY);
  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }
  return config;
});

let refreshPromise = null;

export function refreshSession() {
  if (!refreshPromise) {
    refreshPromise = axios
      .post(`${BACKEND_URL}/api/auth/refresh`, null, { withCredentials: true })
      .then((response) => {
        window.localStorage.setItem(TOKEN_KEY, response.data.access_token);
        return response.data;
      })
      .finally(() => {
        refreshPromise = null;
      });
  }
  return refreshPromise;
}

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config;
    const path = original?.url || "";
    if (error.response?.status !== 401 || original?._retried || NO_RETRY.some((skip) => path.startsWith(skip) || path.startsWith(`/api${skip}`))) {
      throw error;
    }
    original._retried = true;
    try {
      const session = await refreshSession();
      original.headers.Authorization = `Bearer ${session.access_token}`;
    } catch (refreshError) {
      window.localStorage.removeItem(TOKEN_KEY);
      window.dispatchEvent(new CustomEvent("tagforce:unauthorized", { detail: { status: 401 } }));
      throw error;
    }
    return api(original);
  },
);

export function formatApiError(error) {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string") {
    return detail;
  }
  if (Array.isArray(detail)) {
    return detail.map((item) => item?.msg).filter(Boolean).join(" ");
  }
  return "We could not complete that request. Please try again.";
}
